import { Box, Grid, Modal, Typography } from "@mui/material";
// import { StudentTable } from "../StudentPages/components/StudentTable";
import { useEffect, useState } from "react";
import { DashboardStats, MeQuery, ParentalConsentType, QueryOrigin, Student } from "../../__generated__/graphql";
import { studentData, useStudentContext } from "../../context/studentContext";
import RiskWarningGrid from "./components/RiskWarningGrid";
import { useNavigate } from "react-router";
import { gql, useLazyQuery } from "@apollo/client";
import usePersonStore, { PersonModel, SubscriptionModel } from "../store/personStore";
import usePersonAuthStore, { decodedToken } from "../store/personAuthStore"
import { useUserData } from "../Manage/hooks/useUserData";
import GenericChip from "./components/InfoChips/GenericChip";
import { AssignmentTurnedIn, Pending, Person } from "@mui/icons-material";
import { PendingStudentsModal } from "./components/PendingStudentsModal";
import SampleRiskWarningGrid from "./components/RiskWarningGrid/SampleRiskWarningGrid";
import StudentTableComponent from "../StudentPages/components/StudentTableComponent";
import { tutorialSectionType, useTourContext } from "../../context/TourContext";
const QUERY_ME = gql(`
  query Me {
    me {
      __typename
      id
      firstName
      lastName
      company {
        __typename
        id
        type
        name
        paidUsers
        activeUsers
        companySubscriptions{
            id
            subscription{
            id
            name
            }
        }
        companyConsentPolicy{
            needParentalConsent
            autoParentalConsent
        }
      }
      
    dashboardStats{
        currentLocationStudents
        totalStudents
        sessionsCompleteThisWeek
        changeFromLastWeek
        pendingConsent    
    }
      locations{
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges{
            node {
                id
                name
                streetLineOne
                streetLineTwo
                city
                state
                postalCode
                country
                customFields{
                    __typename
                    id
                    type
                    name
                    position    
                }
            }
        }
      }

        workLists(status:UNREAD){id}
      defaultLocation {
        __typename
        id
        name
        streetLineOne
        streetLineTwo
        city
        state
        postalCode
        country
        demoStudent{
            id
        }
        customFields {
            __typename
            id
            type
            name
            position
        }
      }
    }
  }
    `);

const MY_PENDING_STUDENTS = gql(`
query pendingStudents($origin:QueryOrigin!, $first:Int){
  students(origin: $origin, first:$first){
    edges{
      node{
        id
        firstName
        lastName
        location{
            name
        }
        parentalConsentStatus
      }
    }
  }
}`)
const mapEdgesToTable = (data: any) => {
    return {
        ...data.node,
        location: data.node
    }
}
function transformToState(data: MeQuery): PersonModel {
    return {
        id: data.me?.id,
        name: `${data.me?.firstName} ${data.me?.lastName}`,
        company: {
            id: data.me?.company.id,
            name: `${data.me?.company.name}`,
            paidUsers: data.me?.company.paidUsers,
            activeUsers: data.me?.company.activeUsers,
            defaultLocation: (data.me?.defaultLocation as any),
            type: `${data.me?.company.type}`,
            subscriptions: data.me?.company.companySubscriptions.map((x: any) => x.subscription as SubscriptionModel) ?? [],
            consentPolicy: data.me?.company.companyConsentPolicy.needParentalConsent ?? false,
            parentEmailNeeded: data.me?.company.companyConsentPolicy.autoParentalConsent ?? false
        },
        totalUnreadWorkLists: data?.me?.workLists.length ?? 0,
        locations: data?.me?.locations?.edges?.map(mapEdgesToTable) ?? [] as any
    }
}


export function DashboardPage() {
    const navigate = useNavigate();

    const [activeRecord, setActiveRecord] = useState<Student | null>(null);
    const [openPendingModal, setOpenPendingModal] = useState<boolean>(false);
    const roles = usePersonAuthStore((state) => state.roles);
    const firstSignIn = usePersonAuthStore(state => state.firstSignIn);
    const [queryMe] = useLazyQuery(QUERY_ME, { notifyOnNetworkStatusChange: true });
    const [dashboardStats, setDashboardStats] = useState<DashboardStats>({
        currentLocationStudents: 0,
        totalStudents: 0,
        sessionsCompleteThisWeek: 0,
        changeFromLastWeek: 0,
        pendingConsent: 0,
    });
    const [pendingStudents, setPendingStudents] = useState<studentData[]>([]);
    const personState = usePersonStore(state => state)
    const { tutorialSection } = useTourContext();
    const subscriptions = usePersonStore(state => state.company.subscriptions)
    const { loading, FetchUserData } = useUserData()
    const [getPendingStudents] = useLazyQuery(MY_PENDING_STUDENTS, { variables: { origin: QueryOrigin.Pending }, fetchPolicy: "network-only" })
    useEffect(() => {
        FetchUserData()
    }, [])
    const setPersonStoreState = usePersonStore(state => state.setState);
    useEffect(() => {
        queryMe().then(response => {
            setDashboardStats({
                currentLocationStudents: response?.data?.me?.dashboardStats?.currentLocationStudents,
                totalStudents: response?.data?.me?.dashboardStats?.totalStudents,
                sessionsCompleteThisWeek: response?.data?.me?.dashboardStats?.sessionsCompleteThisWeek,
                changeFromLastWeek: response?.data?.me?.dashboardStats?.changeFromLastWeek,
                pendingConsent: response?.data?.me?.dashboardStats?.pendingConsent
            })
            setPersonStoreState(transformToState(response.data))
        });
        getPendingStudents({ variables: { origin: QueryOrigin.Pending, first: 100 }, fetchPolicy: "network-only" }).then(response => {
            const students = response?.data?.students?.edges
                ?.map((edge: any) => edge?.node)
                .filter(Boolean) ?? [];
            setPendingStudents(students);
        })
    }, []);

    const handleActionItem = (record: any) => {
        //@ts-ignore
        const edge = activeRecord?.students?.edges?.find(item => item.node.id === record.studentId) as StudentsEdge
        navigate(`/dashboard/student/${record.studentId}/sessions`)
        if (edge) {
            setActiveRecord(edge.node)
        }
    }

    const handleFilterStudents = async () => {
        setOpenPendingModal(true)
    }

    return (
        <>

            {/* {Tour} */}
            <PendingStudentsModal students={pendingStudents} openPendingModal={openPendingModal} handleClosePendingModal={() => setOpenPendingModal(false)} />
            <Grid data-tour="dashboard" container rowSpacing={4} sx={{ paddingBottom: 4 }}>
                <Grid size={12}>
                    <Grid container spacing={1} sx={{ marginTop: 3 }}>
                        <Grid size={4}>
                            <GenericChip
                                dataTour="active-students"
                                subAction="-view-all"
                                title={
                                    !roles.includes("SUPPORT ADMIN") ? (
                                        <Typography>
                                            {personState.company?.defaultLocation?.name}:{" "}
                                            <Typography
                                                component="span"
                                                color="primary"
                                                fontSize="18px"
                                                fontWeight={500}
                                            >
                                                {dashboardStats?.currentLocationStudents}
                                            </Typography>{" "}
                                            Children
                                        </Typography>
                                    ) : (
                                        <Typography>
                                            All Locations:{" "}
                                            <Typography
                                                component="span"
                                                color="primary"
                                                fontSize="18px"
                                                fontWeight={500}
                                            >
                                                {dashboardStats?.totalStudents}
                                            </Typography>{" "}
                                            Children
                                        </Typography>

                                    )
                                }
                                subtitle={
                                    personState.locations.length > 1 && !roles.includes("SUPPORT ADMIN") ?
                                        <Typography>
                                            All Locations:{" "}
                                            <Typography
                                                component="span"
                                                color="primary"
                                                fontSize="18px"
                                                fontWeight={500}
                                            >
                                                {dashboardStats?.totalStudents}
                                            </Typography>{" "}
                                            Children
                                        </Typography>
                                        : <></>
                                }
                                icon={
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center", width: "56px", height: "56px", backgroundColor: "rgba(37, 61, 147, 0.35)"
                                            , borderRadius: 1,
                                        }}>
                                        <Person color="secondary" sx={{ fontSize: "56px", color: "secondary" }} />
                                    </Box>}
                            // testOrAction="View All Students"
                            // onClick={() => navigate("/manage/children")}
                            />
                        </Grid>
                        <Grid size={4}>
                            <GenericChip
                                title={`This Week: ${dashboardStats?.sessionsCompleteThisWeek} sessions`}
                                dataTour="sessions-complete-this-week"
                                subtitle=""
                                icon={
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center", width: "56px", height: "56px", backgroundColor: "rgba(131,164,123, 0.35)"
                                            , borderRadius: 1,
                                        }}>
                                        <AssignmentTurnedIn color="primary" sx={{ fontSize: "56px" }} />
                                    </Box>}
                                testOrAction={`${dashboardStats?.changeFromLastWeek} vs last week`} />
                        </Grid>
                        <Grid size={4}>
                            {personState?.company?.consentPolicy ?
                                (
                                    <GenericChip
                                        dataTour="view-pending"
                                        title={`Pending Consent: ${dashboardStats.pendingConsent}`}
                                        // subtitle={`${dashboardStats.pendingConsent}`}
                                        subtitle=""
                                        icon={
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center", width: "56px", height: "56px", backgroundColor: "rgba(252, 211 ,77,.5)"
                                                    , borderRadius: 1,
                                                }}>
                                                <Pending sx={{ fontSize: "56px", color: "yellow.dark" }} />
                                            </Box>}
                                        testOrAction={dashboardStats.pendingConsent > 0 ? "View Pending" : ""}
                                        onClick={dashboardStats.pendingConsent > 0 ? handleFilterStudents : undefined}
                                    />
                                ) : (<></>)}

                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={8}>
                    <Box component="div" sx={{ marginTop: 4 }}>
                        {firstSignIn ? (<SampleRiskWarningGrid data-tour="actions-needed" />) : (
                            tutorialSection == "actionsNeeded" && personState.totalUnreadWorkLists == 0 ?
                                (<SampleRiskWarningGrid data-tour="actions-needed" />) : (
                                    < RiskWarningGrid data-tour="actions-needed" onClickResults={handleActionItem} />
                                )
                        )}
                    </Box>
                </Grid>
                <Grid size={12} id="studentTableDash" data-tour="your-students">
                    <StudentTableComponent roles={roles} subscriptions={subscriptions} />
                </Grid>
            </Grid >
        </>
    )
}
